import PersonIcon from '@mui/icons-material/Person';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ClientIcon(props: FixMe) {
  return <PersonIcon {...props} />;
}

export default ClientIcon;
